module.exports = __webpack_public_path__ + "img/starmap_square_q90_lossy.d739be22.webp";